
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tc/about",
      function () {
        return require("private-next-pages/tc/about.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tc/about"])
      });
    }
  